import React from 'react';
import './QUDRA.css';
import { Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router';
import logo from '../../Raya logo/Qudra-Logo__1_-removebg-preview.png'
import cover from '../../Raya logo/Qudra-Logo__1_-removebg-preview.png'
const QUDRA = () => {
    const navigate = useNavigate();

    const transferToPage = ()=>{
        // navigate('/Louco');
        window.open('https://www.linkedin.com/company/qudra-group/?viewAsMember=true')
    }

    return (
        <div className='main-first-section newBrandd'>
            <Container maxWidth="xl">
                <div className='content'>
                    <div className='text-container'>
                        {/* <img src={logo} style={{width:'100%' , height:'100%'}}  alt='logo not found'/> */}
                        <h1>Franchise Growth & Investment</h1>
                        <h3>Scaling remarkable brands across markets.</h3>
                        <ArrowForwardIcon   onClick={transferToPage} style={{fontSize:'22px' , border:'1px solid #000' ,marginTop:'0px' ,  borderRadius:'50%' , padding:'4px' , cursor:'pointer'}}/>
                    </div>
                    <div className='louco-header-img'>
                        <img src={cover} alt="mobile image not found"/>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default QUDRA;
